import React, { useState } from "react";
import { IconExpandMore } from "../../../assets/icons";

const FilterSection = ({ setFilterOptions }) => {
  const [openSections, setOpenSections] = useState({
    category: true,
    brand: false,
    screen: false,
    memory: false,
  });
  const toggleSection = (section) =>
    setOpenSections((prev) => ({ ...prev, [section]: !prev[section] }));

  // HARD CODE
  const filtersData = [
    {
      id: "category",
      title: "Loại sản phẩm",
      options: [
        { keyValue: "iPhone", renderValue: "iPhone" },
        { keyValue: "iPad", renderValue: "iPad" },
        { keyValue: "watch", renderValue: "Watch" },
        { keyValue: "airpods", renderValue: "AirPods" },
        { keyValue: "airtag", renderValue: "AirTag" },
        { keyValue: "accessories", renderValue: "Phụ kiện" },
      ],
    },
  ];

  // Handle checkbox change
  const handleOptionChange = (filterId, keyValue, checked) => {
    setFilterOptions((prev) => {
      const updatedOptions = { ...prev };
      if (checked) {
        // Add option to the filter
        if (!updatedOptions[filterId]) updatedOptions[filterId] = [];
        if (!updatedOptions[filterId].includes(keyValue)) {
          updatedOptions[filterId].push(keyValue);

          // Add search parameter to URL
          const url = new URL(window.location);
          url.searchParams.set(filterId, updatedOptions[filterId].join(","));
          window.history.pushState({}, "", url);
        }
      } else {
        // Remove option from the filter
        updatedOptions[filterId] = updatedOptions[filterId]?.filter(
          (item) => item !== keyValue
        );

        if (updatedOptions[filterId]?.length === 0) {
          delete updatedOptions[filterId]; // Remove empty filters
        }

        // Update search parameter in URL
        const url = new URL(window.location);
        if (updatedOptions[filterId]?.length > 0) {
          url.searchParams.set(filterId, updatedOptions[filterId].join(","));
        } else {
          url.searchParams.delete(filterId);
        }
        window.history.pushState({}, "", url);
      }
      return updatedOptions;
    });
  };

  const urlParams = new URLSearchParams(window.location.search);
  const defaultCategory = urlParams.get("category");

  return (
    <div>
      {filtersData.map((filter) => (
        <div key={filter.id} className="mb-6">
          {/* Header */}
          <div
            className="flex justify-between items-center cursor-pointer py-2"
            onClick={() => toggleSection(filter.id)}
          >
            <span className="font-semibold text-lg">{filter.title}</span>
            <IconExpandMore
              className={`fill-black transition-transform ${
                openSections[filter.id] ? "-rotate-180" : "rotate-0"
              }`}
            />
          </div>
          <hr className="h-1" />

          {/* Options */}
          {openSections[filter.id] && (
            <div className="flex flex-col mt-2 space-y-4 lg:space-y-2 text-2xl lg:text-base">
              {filter.options.map((option) => (
                <label
                  key={option.keyValue || option}
                  className="cursor-pointer"
                >
                  <input
                    type="checkbox"
                    className="mr-4 lg:mr-2 w-6 h-6 lg:w-4 lg:h-4"
                    onChange={(e) =>
                      handleOptionChange(
                        filter.id,
                        option.keyValue,
                        e.target.checked
                      )
                    }
                    defaultChecked={
                      filter.id === "category" &&
                      defaultCategory &&
                      defaultCategory
                        .toLowerCase()
                        .split(",")
                        .includes((option.keyValue || option).toLowerCase())
                    }
                  />
                  {option.renderValue || option}
                </label>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FilterSection;
